var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-dropdownbutton',{attrs:{"items":_vm.items,"css-class":"e-caret-hide grid-action p-0","select":_vm.onSelect,"open":_vm.onOpen}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'ellipsis-v'],"size":"sm"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }